export const availableCountries = [
  { id: 'AE', text: 'United Arab Emirates' },
  { id: 'SA', text: 'Saudi Arabia' },
  { id: 'KW', text: 'Kuwait' },
  { id: 'BH', text: 'Bahrain' },
  { id: 'OM', text: 'Oman' },
  { id: 'QA', text: 'Qatar' },
  { id: 'EG', text: 'Egypt' },
  { id: 'SS', text: 'South Sudan' },
  { id: 'SD', text: 'Sudan' },
  { id: 'LB', text: 'Lebanon' },
  { id: 'JO', text: 'Jordan' },
  { id: 'PS', text: 'Palestine' },
  { id: 'SY', text: 'Syria' },
  { id: 'IQ', text: 'Iraq' },
  { id: 'DZ', text: 'Algeria' },
  { id: 'LY', text: 'Libya' },
  { id: 'MA', text: 'Morocco' },
  { id: 'TN', text: 'Tunisia' },
  { id: 'ROW', text: 'Rest of the World' }
];

export const genderOptions = [
  { id: 'male', text: 'Male' },
  { id: 'female', text: 'Female' }
];

export const goalOptions = [
  { id: 'max', text: 'Maximum Available' },
  { id: 'custom', text: 'Custom Number' }
];

export const frequencyCapDurations = [
  { id: 'day', text: 'day' },
  { id: 'week', text: 'week' },
  { id: 'month', text: 'month' },
  { id: 'lifetime', text: 'lifetime' }
];
